import { notifRoute, type NotifRoute } from '../../../lib/notification-route';
import { notifMeta } from '../../../lib/notification-meta';
import { boxPath } from '../../ApprovalPage/box/approval-box-types';

/**
 * 대시보드 「알림」 위젯 — 행을 누르면 갈 곳 (2026-09-15).
 *
 * ★★ 종전에는 **어떤 알림이든 `/board`** 로 갔다(`InfoWidgets.tsx` 의 `go('/board')`) — 결재 차례 알림을
 *    눌러도 게시판이 열렸다(디자인 피어 대시보드 조사에서 발견).
 *
 * 알림 팝업과 **같은 표**(`lib/notification-route`)를 쓰고, 그 표가 아직 비워 둔 **결재만** 여기서 채운다.
 * 그 표가 결재를 «갈 곳 없음»으로 둔 것은 결재 라우트가 없던 때(2026-08-18)의 판단이고, 지금은
 * `/approval/doc/:id` · `/approval/box` 가 있다. 앱 #1361 과 같은 방식 — `source` 로 고르고 `sourceId` 로 연다.
 *
 * ★ `notifRoute` 자체는 바꾸지 않는다 — 알림 팝업의 «결재는 갈 곳 없음» 계약이 시험에 박혀 있다
 *   (`lib/notification-route.test.ts`). 팝업도 옮길지는 후속으로 남긴다.
 * ★ 표가 모르는 알림(시스템 등)은 **종전대로** `/board` 다.
 */
interface WidgetNotification {
  type: string;
  source?: string;
  sourceId?: string | null;
}

export const WIDGET_NOTIFICATION_FALLBACK = '/board';

export function widgetNotificationTarget(n: WidgetNotification): NotifRoute {
  if (notifMeta(n.type, n.source ?? '').categoryKey === 'notif.cat.approval') {
    // 서버 `approval-notify.ts` — source 'approval' 의 sourceId 는 문서 번호다(결재 차례 · 참조).
    return n.source === 'approval' && n.sourceId
      ? { to: `/approval/doc/${encodeURIComponent(n.sourceId)}` }
      : { to: boxPath('wait') };
  }
  return notifRoute(n) ?? { to: WIDGET_NOTIFICATION_FALLBACK };
}
